import { initialRunState, type RunViewState } from './run-reducer';
import { safeStorage } from './utils';

/**
 * Persists the reduced state of a streaming run (incl. lastSeq) so a page reload can
 * resume the SSE stream from `after=lastSeq` instead of replaying everything.
 */
const KEY = (runId: string) => `af:run:${runId}`;
const INDEX = 'af:run-index';
const MAX_STORED = 20;

export function loadRunSnapshot(runId: string): RunViewState {
  const snap = safeStorage.get<RunViewState>(KEY(runId));
  if (!snap || typeof snap.lastSeq !== 'number' || !Array.isArray(snap.parts)) return initialRunState();
  return snap;
}

export function saveRunSnapshot(runId: string, state: RunViewState) {
  safeStorage.set(KEY(runId), state);
  const idx = (safeStorage.get<string[]>(INDEX) ?? []).filter((id) => id !== runId);
  idx.push(runId);
  while (idx.length > MAX_STORED) {
    const old = idx.shift();
    if (old) safeStorage.remove(KEY(old));
  }
  safeStorage.set(INDEX, idx);
}

export function clearRunSnapshot(runId: string) {
  safeStorage.remove(KEY(runId));
}

/** Last live run per conversation, so the chat can re-attach after reload. */
export const liveRunStore = {
  get: (conversationId: string) => safeStorage.get<string>(`af:conv-live:${conversationId}`),
  set: (conversationId: string, runId: string) => safeStorage.set(`af:conv-live:${conversationId}`, runId),
  clear: (conversationId: string) => safeStorage.remove(`af:conv-live:${conversationId}`),
};
